import { useI18n } from '../i18n/I18nProvider'
import { LANGUAGES, LANGUAGE_LABELS, LANGUAGE_SHORT } from '../i18n/messages'

/**
 * Bascule de langue.
 *
 * Les boutons se déduisent de `LANGUAGES` et jamais d'une liste écrite à la main : c'est
 * ainsi que l'anglais avait disparu de la barre supérieure — deux boutons codés en dur,
 * une langue pourtant complète dans le dictionnaire, et personne pour s'en apercevoir.
 * Une langue ajoutée au dictionnaire apparaît ici sans qu'on y touche.
 *
 * `compact` rend le code à deux lettres pour la barre supérieure ; le nom complet reste
 * accessible par `aria-label`, faute de quoi « FR » se lit « eff erre » au lecteur d'écran.
 */
export function LanguageToggle({ compact = false }: { compact?: boolean }) {
  const { language, setLanguage } = useI18n()

  return (
    <div className="langswitch" role="group">
      {LANGUAGES.map((code) => (
        <button
          key={code}
          type="button"
          className={`tbtn ${language === code ? 'on' : ''}`}
          aria-pressed={language === code}
          aria-label={LANGUAGE_LABELS[code]}
          lang={code}
          onClick={() => setLanguage(code)}
        >
          {compact ? LANGUAGE_SHORT[code] : LANGUAGE_LABELS[code]}
        </button>
      ))}
    </div>
  )
}
